import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  height: 100%;
`;

export const Column = styled.ul`
  padding: 32px 0 0 0;
  margin: 0;
  /* &:not(&:last-child) {
    border-right: 1px solid #dbd9d9;
  } */
  height: 100%;
`;

export const Row = styled.li`
  display: flex;
  padding: 3px 10px;
  list-style: none;
  /* height: 30px; */
  width: 208px;
  &:hover {
    cursor: pointer;
    background: #F3F3F7;
    /* background: #dfdedf; */
    /* background: linear-gradient(to right, #dfdedf 50%, #d9d4d4 100%); */
  }

  background: ${({ active }) => active ? '#F3F3F7' : 'none'};

  svg {
    transform: translateY(2px);
    width: 1em;
    height: 1em;
  }
`;

export const RowLinkText = styled.span`
  width: 100%;
  font-size: 14px;
  padding-left: 7px;
  overflow: hidden;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
